/**
 * Purchase Shares Page
 */
import React from 'react';

const PurchaseShares = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Purchase Shares</h1>
      <p className="text-gray-600 dark:text-gray-400 mt-2">Buy shares for a member</p>
    </div>
  );
};

export default PurchaseShares;
